/**
 * Used in async tests when several async behaviors are happening
 * in the background
 *
 * @param waitMs
 */
export function wait(waitMs: number = 5): Promise<null> {
  return new Promise((res) => setTimeout(() => res(null), waitMs));
}
